import { getLeaderBoard } from "../../../services/api/queries/users";

const leaderboardListViewMeta = ({ topic_id } = {}) => {
  return {
    columns: [
      {
        Header: "Rank",
        accessor: "rank",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "Name",
        Cell: ({ row }) => {
          const first = row.original?.first_name || "";
          const last = row.original?.last_name || "";
          return `${first} ${last}`.trim() || "Anonymous User";
        },
      },
      { Header: "Score", accessor: "total_marks" },
      { Header: "Correct Answers", accessor: "total_correct_answer" },
      { Header: "Wrong Answers", accessor: "total_wrong_answer" },
      { Header: "Negative Marks", accessor: "total_negative_marks" },
      {
        Header: "Highest Score",
        accessor: "highest_mark",
        Cell: ({ rows }) => {
          if (!rows || !rows.length) return "-";
          return rows[0]?.original?.total_marks ?? "-";
        },
      },
    ],
    actions: [],
    queryService: (page) =>
      getLeaderBoard({
        template: topic_id,
        page: page.page,
        page_size: page.page_size,
      }),
  };
};

export default leaderboardListViewMeta;
